export default __webpack_public_path__ + "static/media/how-does-it-work-1.1c624ad2.png";